import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-satisfaction-love",
  "use": "icon-satisfaction-love-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-satisfaction-love\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.0084 27.5931C14.5694 27.5931 14.1642 27.4581 13.8096 27.171C13.5225 26.9346 6.51501 21.5143 3.71201 17.1072C2.7833 15.6551 1.5 13.6795 1.5 10.8765C1.5 6.19915 4.99531 2.3999 9.26735 2.3999C11.4456 2.3999 13.5225 3.39615 15.0084 5.13536C16.4775 3.37926 18.5375 2.3999 20.7326 2.3999C25.0216 2.3999 28.5 6.19915 28.5 10.8765C28.5 13.6288 27.3011 15.52 26.3218 17.0566L26.288 17.1072C23.485 21.5143 16.4775 26.9515 16.1904 27.171C15.8527 27.4412 15.4475 27.5931 15.0084 27.5931Z\" fill=\"#C8D3DF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/satisfaction-love.svg
// module id = Zf0a
// module chunks = 6 7